exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-content {\n  margin: auto; }\n\n.contact-name {\n  margin-top: .6rem; }\n\n.mat-row {\n  height: 58px; }\n\n.result-row {\n  height: 70px; }\n\n.date-column {\n  -ms-flex: 0 0 220px;\n      flex: 0 0 220px;\n  color: #c5c5c5; }\n\n.action-column {\n  -ms-flex: 0 0 50px;\n      flex: 0 0 50px; }\n\n.consigna-finalizada {\n  color: #A2A2A2;\n  position: relative; }\n\n.consigna-finalizada:after {\n  position: absolute;\n  left: 0;\n  top: 41%;\n  height: 1px;\n  background: #A2A2A2;\n  content: \"\";\n  width: 100%;\n  display: block; }\n\n.consigna-nombre {\n  float: left;\n  margin-left: 20px;\n  margin-top: 5px;\n  width: calc(80% - 81px); }\n\n.profile-picture {\n  height: 40px;\n  width: 40px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/buscador/buscador/buscador.component.scss
// module id = ../../../../../src/app/components/buscador/buscador/buscador.component.scss
// module chunks = 0